module.exports = __webpack_public_path__ + "img/1-21-5.ed09ea93.png";